import { render, staticRenderFns } from "./CustomFieldsQuestions.vue?vue&type=template&id=a1ffc97a&scoped=true&"
import script from "./CustomFieldsQuestions.vue?vue&type=script&setup=true&lang=js&"
export * from "./CustomFieldsQuestions.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1ffc97a",
  null
  
)

export default component.exports